import { getCookie } from './utils';

export const getLocaleFromCookie = (name) => getCookie(name);
